import { Link, useLocation } from "react-router-dom";
import { MdHome, MdReceipt, MdQrCode, MdLockClock } from "react-icons/md";
import { RiFileList3Line } from "react-icons/ri";
import { CiViewList } from "react-icons/ci";

const Navbar = () => {
  const location = useLocation();

  const navItems = [
    { path: "/", icon: MdHome, label: "الرئيسية" },
    { path: "/qr-subscription", icon: MdQrCode, label: "الاشتراكات والهدايا" },
    { path: "/orders", icon: CiViewList, label: "الطلبات" },
    { path: "/invoices", icon: MdReceipt, label: "الفواتير" },
    { path: "/receipts", icon: RiFileList3Line, label: "إيصالات الدفع" },
    { path: "/sales", icon: MdLockClock, label: "المبيعات" },
  ];

  return (
    <nav className=' fixed bottom-0 left-0 right-0 z-50 border-t bg-background/95 backdrop-blur  pb-8 supports-[backdrop-filter]:bg-background/60'>
      <div className='container mx-auto'>
        <div className='flex h-16 items-center justify-around'>
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex flex-col items-center space-y-1 ${
                  isActive ? "text-red-700" : "text-muted-foreground"
                }`}
              >
                <Icon className='h-6 w-6' />
                <span className='text-xs'>{item.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
